import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import HomeModulesManagement from '../../../components/siteadmin/HomeModulesManagement/HomeModulesManagement';
import { restrictUrls } from '../../../helpers/adminPrivileges';

const title = 'Home Modules';

export default async function action({ store }) {
  // From Redux Store
  let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  let privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  // Admin restriction - use same privilege as home page banner
  if (!restrictUrls('/siteadmin/home/banner', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><HomeModulesManagement title={title} /></AdminLayout>,
  };
}
